<!--优秀企业家 基本信息录入-->
<template>
   <div class="contentRight">
      <div class="inputList">
         <el-form ref="inputForm" :model="form" label-width="180px" label-suffix=":">
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="姓名" prop="realname"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.realname"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="性别" prop="sex" :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-select v-model="form.sex" filterable remote reserve-keyword placeholder="请选择"
                             style="width: 100%">
                     <el-option v-for="(item,i) in ddl.sex" :key="item.value" :label="item.text"
                                :value="item.value">
                     </el-option>
                  </el-select>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="学历" prop="education"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-select v-model="form.education" filterable remote reserve-keyword placeholder="请选择"
                             style="width: 100%">
                     <el-option v-for="(item,i) in ddl.education" :key="item.value" :label="item.text"
                                :value="item.value">
                     </el-option>
                  </el-select>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="出生日期" prop="birthdate"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-date-picker v-model="form.birthdate" value-format="yyyy-MM-dd"
                                  style="width: 100%"></el-date-picker>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="职务" prop="post" :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.post"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="任职时间" prop="postDate"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-date-picker v-model="form.postDate" value-format="yyyy-MM-dd"
                                  style="width: 100%"></el-date-picker>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="职称" prop="title"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.title"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="政治面貌" prop="political"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.political"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="申报人邮箱" prop="email"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.email"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="申报人手机号" prop="cellphone"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.cellphone"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="身份证号码" prop="id_card"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.id_card"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="推荐单位" prop="recommend_unit"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-select v-model="form.recommend_unit" filterable remote reserve-keyword
                             placeholder="请选择推荐单位" style="width: 100%">
                     <el-option v-for="(item,i) in ddl.recomList" :key="item.value" :label="item.text"
                                :value="item.value">
                     </el-option>
                  </el-select>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="联系人姓名" prop="contact_name"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.contact_name"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="联系人职务" prop="contact_post"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.contact_post"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="联系人邮箱" prop="contact_email"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.contact_email"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="联系人手机号" prop="contact_cellphone"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.contact_cellphone"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="单位名称" prop="company_name"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.company_name" :disabled="true"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px;padding-right: 30px;">
               <el-form-item label="单位地址" prop="company_address"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.company_address"/>
               </el-form-item>
            </el-col>
         </el-form>
      </div>
      <div class="uploadBtn" v-if="isEdit" style="margin-top: 5px; margin-bottom: 5px;">
         <el-button type="primary" @click="_saveData">保存</el-button>
      </div>
   </div>
</template>

<script>
   import {getCompanyInfoByLoginUser,getRecomCompany} from '@/api/modules/project'
   import {
      getApplyBasicInfo,
      postApplyBasicInfo
   } from '@/api/modules/advEnterpriserApply'
   import labelInput from '@/components/table/labelInput.vue'
   import labelSelect from '@/components/table/labelSelect';
   import ruiTool from "@/utils/ruiTool";
   import {vaildte} from "@/utils/validate";

   export default {
      data() {
         return {
            //表单字段
            form: {
               opMode: '',
               project_application_id: '',
               id: '',
               realname: '',
               sex: '',
               education: '',
               birthdate: '',
               post: '',
               postDate: '',
               title: '',
               political: '',
               email: '',
               cellphone: '',
               id_card: '',
               contact_name: '',
               contact_post: '',
               contact_email: '',
               contact_cellphone: '',
               company_name: '',
               company_address: '',
               recommend_unit: '',
               photo_url: '',
               resume: ''
            },
            ddl: {
               /*推荐单位*/
               recomList: [],
               /*性别*/
               sex: [{value: 1, text: '男'}, {value: 2, text: '女'}],
               /*学历*/
               education: [{value: '大专', text: '大专'}, {value: '本科', text: '本科'}, {
                  value: '研究生',
                  text: '研究生'
               }, {value: '博士', text: '博士'}]
            }
         }
      },
      computed: {
         isEdit() {
            return this.form.opMode == 'edit';
         }
      },
      components: {
         labelInput,
         labelSelect
      },
      mounted() {
         //获取保存的传入参数
         this.form.project_application_id = localStorage.getItem("prjApplyCode")
         this.form.project_code = localStorage.getItem("prjCode");
         this.form.opMode = localStorage.getItem("opMode");

         //获取登录企业编号
         this.form.loginName = localStorage.getItem('loginName');
         this.form.company_code = localStorage.getItem('company_code');

         if (ruiTool.isNull(this.form.project_application_id)) {
            //新增模式
            this._getCompanyInfo();
            this._getRecomCompany();
         } else {
            //修改模式，展示原数据
            getApplyBasicInfo({
               data: {prjApplyID: this.form.project_application_id},
               success: (res) => {
                  //数据赋值
                  Object.keys(res.data.item).forEach((key) => {
                     this.form[key] = res.data.item[key]
                  })
                  this._getRecomCompany();
               }
            })
         }
      },
      methods: {
         _checkInput() {
            if (!vaildte.isEmail(this.form.email)) {
               this.$message.error('请输入合法的申报人邮箱');
               return false;
            }
            if (!vaildte.isPhone((this.form.cellphone))) {
               this.$message.error('请输入合法的申报人手机号');
               return false;
            }
            if (!vaildte.isIdCard(this.form.id_card)) {
               this.$message.error('请输入合法的身份证号码');
               return false;
            }
            if (!vaildte.isEmail(this.form.contact_email)) {
               this.$message.error('请输入合法的联系人邮箱');
               return false;
            }
            if (!vaildte.isPhone(this.form.contact_cellphone)) {
               this.$message.error('请输入合法的联系人手机号');
               return false;
            }
            return true;
         },
         /*提交基本数据*/
         async _saveData() {
            this.$refs['inputForm'].validate((valid) => {
               if (valid) {
                  if(this._checkInput()) {
                     postApplyBasicInfo({
                        data: this.form,
                        success: (res) => {
                           Object.keys(res.data.item).forEach((key) => {
                              this.form[key] = res.data.item[key];
                           })
                           //将当前申报项目编号保存到本地存储
                           localStorage.setItem("prjApplyCode", this.form.project_application_id);
                           this.$message({
                              message: '保存成功',
                              type: 'success'
                           });
                        }
                     })
                  }
               } else {
                  this.$message.error("存在未填写项");
               }
            })
         },
         /*根据登录账号获取企业默认信息*/
         async _getCompanyInfo() {
            let param = {loginUser: localStorage.getItem('loginName')};
            await getCompanyInfoByLoginUser({
               data: param,
               success: (res) => {
                  console.log(res.data);
                  //默认数据赋值
                  this.form.company_name = res.data.item.name;
                  this.form.company_address = res.data.item.address;
                  this.form.legal_person = res.data.item.legal_person;
                  this.form.legal_phone = res.data.item.cellphone;
               }
            })
         },
         /*获取推荐单位*/
         async _getRecomCompany() {
            let param = {
               project_code: this.form.project_code,
               projectType: localStorage.getItem('projectType')
            }
            await getRecomCompany({
               data: param,
               success: (res) => {
                  console.log('获取推荐单位', res.data);
                  this.ddl.recomList = res.data.ddl;
               }
            })
         },
         /*获取性别*/
         _getSex() {
            getSex({
               success: (res) => {
                  this.ddl.sex = res.data.ddl;
               }
            })
         }
      }
   }
</script>

<style scoped>
   .contentRight {
      width: 100%;
   }

   /* 上传样式 */
   .inputList {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
   }
</style>